import { message } from "antd";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

const HBMessage = {
  success(content, duration, onClose, className) {
    if (typeof window === "undefined") {
      return;
    }

    if (typeof content === "string") {
      if (typeof duration === "function") {
        onClose = duration;
        duration = 3;
      }
      return message.success({
        className: className || styles.message,
        icon: <HBIcon type="ic_check_circle" />,
        content,
        duration,
        onClose,
      });
    } else {
      return message.success({
        className: styles.message,
        icon: <HBIcon type="ic_check_circle" />,
        ...content,
      });
    }
  },
  error(content, duration, onClose) {
    if (typeof window === "undefined") {
      return;
    }
    if (typeof content === "string") {
      if (typeof duration === "function") {
        onClose = duration;
        duration = 3;
      }
      return message.error({
        className: styles.message,
        icon: <HBIcon type="ic_alert" />,
        content,
        duration,
        onClose,
      });
    } else {
      return message.error({
        className: styles.message,
        icon: <HBIcon type="ic_alert" />,
        ...content,
      });
    }
  },
  info(content, duration, onClose) {
    if (typeof window === "undefined") {
      return;
    }
    if (typeof content === "string") {
      if (typeof duration === "function") {
        onClose = duration;
        duration = 3;
      }
      return message.info({
        className: styles.message,
        icon: <HBIcon type="ic_info" />,
        content,
        duration,
        onClose,
      });
    } else {
      return message.info({
        className: styles.message,
        icon: <HBIcon type="ic_info" />,
        ...content,
      });
    }
  },
  open(content, duration, onClose) {
    if (typeof window === "undefined") {
      return;
    }
    if (typeof content === "string") {
      if (typeof duration === "function") {
        onClose = duration;
        duration = 3;
      }
      return message.open({
        className: styles.message,
        content,
        duration,
        onClose,
      });
    } else {
      return message.open({
        className: styles.message,
        ...content,
      });
    }
  },

  /**
   * 深色模式的成功消息提示
   * @param {Object} options
   * @param {React.ReactNode|string} options.content - 消息内容
   * @param {number} [options.duration] - 显示持续时间（毫秒）
   * @param {Function} [options.onClose] - 关闭时的回调函数
   * @param {string} [options.className] - 自定义类名
   * @param {Object} [options] - 其他配置参数
   */
  darkSuccess({ content, duration, onClose }) {
    this.success(content, duration, onClose, styles.darkSuccess);
  },
};

export default HBMessage;
